import { useTranslations } from "next-intl";
import { useTheme } from "@cbex/utils/theme";
import { WcChip, WcGrid, WcStack, WcTypography } from "@bpipartners/webui";
import { ActivitiesByActivityIDsRow } from "@cbex/data-access";
import { mapCbexStatusColours } from "../utils/helperFunctions";
import dayjs from "dayjs";
import React from "react";

export interface ActivityCardExtendedProps {
  cardWidth?: number | string;
  onCardClick?: () => void;
  activity: any;
  hideOrganizationCandidates?: boolean;
}

export const ActivityCardExtended = ({
  cardWidth,
  onCardClick,
  activity,
  hideOrganizationCandidates = false,
}: ActivityCardExtendedProps) => {
  const theme = useTheme();
  const t = useTranslations();

  return (
    <WcGrid
      container
      padding={4}
      id="ActivityCard"
      sx={{
        backgroundColor: theme.appColors.surfaceContainer,
        ":hover": {
          backgroundColor: theme.appColors.surfaceContainerHighest,
          cursor: "pointer",
        },
        minWidth: cardWidth,
      }}
      //@ts-ignore
      onClick={() => onCardClick(activity.moment.id)}
    >
      <WcGrid size={5}>
        <WcStack width="100%" spacing={2}>
          <WcTypography variant="h6">
            {dayjs(activity.moment.startDate).format("DD-MM-YYYY HH:mm")}
          </WcTypography>
          <WcTypography variant="h6">
            {activity.moment.location.city}
          </WcTypography>
          <WcStack direction={"row"} spacing={2}>
            <WcTypography mr={4} variant="body1" width={65}>
              Locatie :
            </WcTypography>
            <WcTypography variant="body1">
              {activity.moment.location.name}
              {", "}
              {activity.moment.location.street}{" "}
              {activity.moment.location.number}
              {activity.moment.location.suffix}
            </WcTypography>
          </WcStack>
          <WcStack pt={3}>
            {!hideOrganizationCandidates && (
              <WcStack direction={"row"}>
                <WcTypography width={170} variant="body2">
                  Aantal kandidaten :
                </WcTypography>
                <WcTypography variant="body2">
                  {activity.totalOrganizationCandidates}
                </WcTypography>
              </WcStack>
            )}

            <WcStack direction={"row"}>
              <WcTypography width={170} variant="body2">
                {hideOrganizationCandidates
                  ? "Aantal kandidaten : "
                  : "Totaal aantal kandidaten :"}
              </WcTypography>
              <WcTypography variant="body2">
                {activity.totalCandidates}
              </WcTypography>
            </WcStack>
          </WcStack>
        </WcStack>
      </WcGrid>
      <WcGrid size={5}>
        <WcStack>
          {activity &&
            activity.activity &&
            activity.activity.length > 0 &&
            activity.activity.map((act: ActivitiesByActivityIDsRow) => (
              <WcTypography key={act.activityID} variant="subtitle1">
                {act.name}
              </WcTypography>
            ))}
        </WcStack>
      </WcGrid>
      <WcGrid size={2}>
        <WcStack spacing={2}>
          <WcChip
            sx={{
              backgroundColor: mapCbexStatusColours(activity.status, theme),
              color: theme.appColors.surfaceContainer,
            }}
            label={t(`value.${activity.status}`)}
          />
          {activity.moment.properties.publicExam && (
            <WcChip
              label={t(`common.publicExam`)}
              sx={{ backgroundColor: theme.appColors.background }}
            />
          )}
        </WcStack>
      </WcGrid>
    </WcGrid>
  );
};
